'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sortAddressData;
function sortAddressData(locale, countryCode, zipCode, city, street, street1) {
    var state = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';

    if (locale === "ja_jp") {
        return [name, zipCode + ' ' + city, street, street1];
    } else if (countryCode === "US") {
        return [name, street, street1, city + ', ' + state + ' ' + zipCode];
    }
    return [name, street, street1, zipCode + ' ' + city];
}


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/sortAddressData.js
// module id = 173
// module chunks = 0